import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Link } from "react-router-dom";

interface LinkPreviewCardProps {
  keyword: string;
  targetUrl: string;
  targetTitle: string | null;
  targetImage: string | null;
  children: React.ReactNode;
}

export const LinkPreviewCard = ({ keyword, targetUrl, targetTitle, targetImage, children }: LinkPreviewCardProps) => {
  return (
    <HoverCard openDelay={300} closeDelay={100}>
      <HoverCardTrigger asChild>
        <Link
          to={targetUrl}
          className="text-primary underline decoration-primary/40 hover:decoration-primary transition-colors"
          title={targetTitle || keyword}
        >
          {children}
        </Link>
      </HoverCardTrigger>
      <HoverCardContent className="w-72 p-3" side="top">
        <div className="flex gap-3">
          {targetImage && (
            <img
              src={targetImage}
              alt={targetTitle || keyword}
              className="w-16 h-16 rounded-md object-cover flex-shrink-0"
            />
          )}
          <div className="min-w-0">
            <p className="font-semibold text-sm truncate">{targetTitle || keyword}</p>
            <p className="text-xs text-muted-foreground truncate mt-1">{targetUrl}</p>
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};
